import React from "react";
import styled from "@emotion/styled";
import { IoIosArrowForward } from "react-icons/io";
import { ClearedStyleButton } from "@modules/Components";
import { SHOW_GUARANTEE_MODAL } from "@constants/actionTypes";
import { defaultAction } from "@actions/defaultAction";
import { useDispatch } from "react-redux";

const ButtonDiv = styled(ClearedStyleButton)`
  width: 218px;
  height: 48px;
  border-radius: 24px;
  background-color: rgba(2, 163, 132, 0.15);
  font-size: 16px;
  font-weight: 500;
  color: #015746;
  cursor: pointer;
  display: grid;
  grid-template-columns: 30px 1fr 30px;
  align-items: center;
  padding-left: 15px;
  padding-right: 15px;
  grid-template-columns: 21px 1fr 10px;
  text-align: center;
  margin-bottom: 30px;
  &:hover {
    background-color: rgba(2, 163, 132, 0.2);
  }
`;

const GuaranteeButton = ({ text }) => {
  const dispatch = useDispatch();

  return (
    <div
      onClick={() =>
        dispatch(
          defaultAction(SHOW_GUARANTEE_MODAL, {
            foreverGuarantee: text === "Forever guarantee"
          })
        )
      }
      className="day-45-guarantee-link"
    >
      <ButtonDiv className="day-45-guarantee-button-div">
        <img
          src="https://cdn.cardcash.com/website/ui/elements/guarantee.svg"
          loading="lazy"
          alt="guarantee"
        />
        <span>{text}</span>
        <IoIosArrowForward
          style={{
            color: "rgba(1, 87, 70, 0.5)",
            fontSize: "16px"
          }}
        />
      </ButtonDiv>
    </div>
  );
};

export default GuaranteeButton;
